import React from "react";
import AppLayout from "../layouts/appLayout";

const ParticipantsDetails = React.lazy(() => import("../pages/participants/participantsDetails"));
const WorkshopDetails = React.lazy(() => import("../pages/3minutesCoach/workshopDetails/workshopDetail"));
const InventoryResponse = React.lazy(() => import("../pages/3minutesCoach/inventoryResponse/inventoryResponse"));
const FollowupResponse = React.lazy(() => import("../pages/3minutesCoach/followupResponse/followupResponse"));
const AdminHomePage = React.lazy(() => import("../pages/adminHome/adminHomePage"));
const IctWorkshopDetails = React.lazy(() => import("../pages/ict/workshopDetails/ictworkshopDetail"));
const IctFollowupResponsePage = React.lazy(() => import("../pages/ict/workshopDetails/ictFollowupResponsePage"));
/**
 * Array of route objects defining the routes for the application pages.
 */
export const appRoutes = [
  {
    path: "", // The base path for the app routes
    element: <AppLayout />, // Renders the AppLayout component for all child routes
    children: [
      {
        path: "companies/:company_id/workshops",
        element: <AdminHomePage />, // Renders the WorkshopList component for the /workshops path
      },
      {
        path: "/companies/:company_id/participants/:participant_id",
        element: <ParticipantsDetails/>, // Renders the partcipant deatils component for the /companies/:company_id/participants path
      },
      {
        path:"/companies/:company_id/workshops/:workshop_id",
        element:<WorkshopDetails/>
      }, 
      {
        path:"/companies/:company_id/workshops/:workshop_id/inventories/:inventory_id/responses",
        element:<InventoryResponse/>
      }, 
      {
        path:"/companies/:company_id/workshops/:workshop_id/followups/:followup_id/responses",
        element:<FollowupResponse/>
      }, 
      {
        path:"/companies/:company_id/ictworkshops/:workshop_id",
        element:<IctWorkshopDetails/>
      },
      {
        path:"/companies/:company_id/ictworkshops/:workshop_id/followups/:followup_id/responses",
        element:<IctFollowupResponsePage/>
      },
    ],
  },
];
